import React from "react";
// Styled
import { WrapperBox, WrapperWithout, LoyaltyInfo, LoyaltyFooter } from './LoyaltyModal.styled'
// Components
import { Button, Loading } from "../../common";
import { LoyaltyHeader } from "./header/LoyaltyHeader";
import { LoyaltyBody } from "./body/LoyaltyBody";
import { Modal } from "vqp-common";
// Services
import useFetch from "../../../utils/useFetch";
import { fetchLoyaltyDetail } from "../../../redux/actions/clients";
// Material UI
import { InfoOutlined as InfoOutlinedIcon } from '@material-ui/icons';

export const ClientLoyaltyModal = ({ client, isOpen, onClose }) => {

    const loyalty = useFetch(fetchLoyaltyDetail, client.id);

    return (
        <Modal isOpen={isOpen} onClose={onClose} boxWidth={loyalty.response ? "832px" : "550px"} >
            {
                loyalty.loading ?
                    (
                        <Loading />
                    ) :
                    !loyalty.response ?
                        (
                            <WrapperWithout>
                                <LoyaltyHeader />
                                <LoyaltyInfo>
                                    <InfoOutlinedIcon />
                                    <span>
                                        O cliente <b>{client.name}</b> não possui fidelidade.
                                    </span>
                                </LoyaltyInfo>
                                <LoyaltyFooter>
                                    <Button
                                        className="primary"
                                        onClick={onClose}
                                    >
                                        Fechar
                                    </Button>
                                </LoyaltyFooter>
                            </WrapperWithout>
                        ) :

                        (
                            <WrapperBox>
                                <LoyaltyHeader />
                                <LoyaltyBody clientName={client.name} loyalty={loyalty.response} />
                            </WrapperBox>
                        )
            }
        </Modal >
    )
}